
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/press/articles/[uid]",
      function () {
        return require("private-next-pages/press/articles/[uid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/press/articles/[uid]"])
      });
    }
  